import { css } from '@emotion/core'
import { colors, measures, font } from 'styles/variables'

const { unit } = measures

export const mobileContainer = css`
  background-color: ${colors.grays.gray6} !important;
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height */
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;
  
  /* Handle safe areas for mobile devices */
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  
  /* Override any parent container backgrounds */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.grays.gray6};
    z-index: -1;
  }
  
  /* Ensure no default background colors from browser */
  * {
    background-color: inherit;
  }
`

export const header = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${6 * unit}px ${4 * unit}px ${4 * unit}px;
  background-color: transparent;
  flex-shrink: 0;
  margin-top: ${4 * unit}px;
  
  /* Ensure all child elements inherit the transparent background */
  * {
    background-color: transparent !important;
  }
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${4 * unit}px;
  top: ${8.5 * unit}px;
`

export const headerContent = css`
  text-align: center;
`

export const title = css`
  color: ${colors.white12};
  font-size: 22px;
  font-weight: ${font.weight.bold};
  font-style: italic;
  margin: 0;
  margin-top: -${2 * unit}px;
  margin-bottom: ${4 * unit}px;
  line-height: 1.2;
  background-color: transparent !important;
  display: block;
`

export const stepIndicator = css`
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.normal};
  margin: 0;
  background-color: transparent !important;
  display: block;
`

export const formContainer = css`
  flex: 1;
  padding: 0 ${4 * unit}px;
  padding-bottom: ${22 * unit}px; /* Add space for fixed footer */
  overflow-y: auto;
  overflow-x: hidden;
  transform: translateY(20px);
  
  /* Enable momentum scrolling on iOS */
  -webkit-overflow-scrolling: touch;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.grays.gray3};
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.grays.gray2};
  }
  
  /* Hide scrollbar on mobile devices */
  @media (max-width: 768px) {
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`

export const sectionTitle = css`
  color: ${colors.white12};
  font-size: 14px;
  font-weight: ${font.weight.semiBold};
  margin: 0 0 ${3 * unit}px 0;
`

export const form = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: ${6 * unit}px;
`

export const inputContainer = css`
  margin-bottom: ${2 * unit}px;
`

export const inputWrapper = css`
  position: relative;
  
  /* Style the FormInput component */
  & > div {
    position: relative;
    border: none !important;
    
    & input {
      width: 100%;
      background-color: transparent !important;
      border: none !important;
      border-radius: 12px !important;
      padding: ${3 * unit}px ${4 * unit}px !important;
      color: ${colors.white12} !important;
      font-size: 13px !important;
      height: 48px !important;
      box-sizing: border-box !important;
      
      &::placeholder {
        color: ${colors.grays.gray2} !important;
        font-size: 13px !important;
      }
      
      &:focus {
        outline: none !important;
      }
    }
    
    /* Hide the default label if present */
    & label {
      display: none !important;
    }
  }
`

export const asteriskNickname = css`
  position: absolute;
  left: ${18 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const asteriskEmail = css`
  position: absolute;
  left: ${12 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const asteriskPassword = css`
  position: absolute;
  left: ${17 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const asteriskConfirm = css`
  position: absolute;
  left: ${28.5 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const asteriskFirstName = css`
  position: absolute;
  left: ${34 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const asteriskLastName = css`
  position: absolute;
  left: ${33 * unit}px;
  top: ${3 * unit}px;
  color: ${colors.greens.green2};
  font-size: 13px;
  font-weight: ${font.weight.bold};
  pointer-events: none;
  z-index: 10;
`

export const buttonContainer = css`
  margin-top: auto;
  padding: 0;
  width: 100%;
`

export const footerForm = css`
  width: 100%;
  max-width: 100%;
`

export const submitButton = css`
  width: 100%;
  background-color: ${colors.greens.green2};
  border: none;
  border-radius: 50px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: ${colors.greens.green3};
  }
  
  &:active {
    background-color: ${colors.greens.green4};
  }
`

export const buttonText = css`
  color: black;
  font-size: 13px;
  font-weight: ${font.weight.semiBold};
  margin: 0;
`

export const progressContainer = css`
  padding: ${2 * unit}px ${4 * unit}px ${4 * unit}px;
  display: flex;
  justify-content: center;
  background: transparent;
`

export const progressBar = css`
  display: none;
  border-radius: 2px;
`

export const footerContainer = css`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${20 * unit}px;
  background-color: rgba(0, 0, 0, 0.3);
  border-top: none;
  backdrop-filter: blur(10px);
  box-shadow: 0 -8px 20px rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${2 * unit}px ${4 * unit}px;
  box-sizing: border-box;
` 